import { createBrowserRouter, RouterProvider } from 'react-router-dom';

import BrowserCheck from './components/browser-check';
import { MQTT_JWT_TOKEN, MQTT_URL, MQTT_USERNAME } from './config';
import { MonitorProvider } from './containers/monitor/monitor.provider';
import { SessionProvider } from './features/session';
import { getRoutes } from './layouts/routes';
import { MqttProvider } from './lib/react-mqtt';

export const App: React.FC = () => {
  return (
    <SessionProvider>
      <MqttProvider url={MQTT_URL} options={{ username: MQTT_USERNAME, password: MQTT_JWT_TOKEN }}>
        <MonitorProvider>
          <BrowserCheck />
          <RouterProvider router={createBrowserRouter(getRoutes())} />
        </MonitorProvider>
      </MqttProvider>
    </SessionProvider>
  );
};
export default App;
